import React from "react";
import AccordionEditable from "../../../../../components/ui/accordions/AccordionEditable";
import DependentsPreview from "../../../../../components/ui/accordions/elements/DependentsPreview";

const DependentsSection = ({
  filing,
  dependents,
  isCpa,
  onAddDependent,
  onEditDependent,
  onDeleteDependent,
}) => {
  const services = Array.isArray(filing.tax_service?.services)
    ? filing.tax_service.services
    : [];

  if (!services.includes("PTF")) return null;

  const ptfSituationForDependents =
    filing.tax_situation?.details?.PTF?.situation;
  const initialDependentsCount =
    ptfSituationForDependents?.haveDependents?.fields?.dependentsCount || 0;
  const hasDependents =
    ptfSituationForDependents?.haveDependents?.value === true &&
    initialDependentsCount > 0;

  // Calculate remaining count logic as it is in Chunk 3
  const remainingCount = Math.max(
    0,
    initialDependentsCount - dependents.length,
  );
  const canAddMore = remainingCount > 0;
  const dependentsHasRequiredActions = remainingCount > 0;
  const dependentsAllComplete = !hasDependents || remainingCount === 0;

  // Metric logic
  const dependentsMetrics = filing.summary_metrics?.dependents;
  const dependentsSectionComplete =
    dependentsMetrics?.complete ?? dependentsAllComplete;
  const dependentsSectionNeedsAttention =
    dependentsMetrics?.attention_needed_cus ?? dependentsHasRequiredActions;

  const dependentsIsWaiting =
    isCpa && !dependentsSectionComplete && dependentsSectionNeedsAttention;

  return (
    <AccordionEditable
      key="dependents"
      title="Dependents"
      hasRequiredActions={!isCpa && dependentsSectionNeedsAttention}
      allActionsComplete={dependentsSectionComplete}
      isWaiting={dependentsIsWaiting}
    >
      <div className="dependents-container">
        <div className="dependents-header-row">
          {hasDependents ? (
            <>
              <div className="section-meta-row">
                <span className="section-meta-item">
                  <span className="section-meta-label">Required:</span>
                  <span className="section-meta-value">{remainingCount}</span>
                </span>
                <span className="section-meta-item">
                  <span className="section-meta-label">Provided:</span>
                  <span className="section-meta-value">
                    {dependents.length}
                  </span>
                </span>
              </div>
              {!isCpa && (
                <button
                  type="button"
                  className="add-item-button"
                  onClick={onAddDependent}
                  disabled={!canAddMore}
                >
                  + Add Dependent
                </button>
              )}
            </>
          ) : (
            <div className="dependents-empty-text">No dependents</div>
          )}
        </div>

        {dependents.length > 0 && (
          <DependentsPreview
            dependents={dependents}
            onEdit={onEditDependent}
            onDelete={onDeleteDependent}
            showActions={!isCpa}
          />
        )}
      </div>
    </AccordionEditable>
  );
};

export default DependentsSection;
